import {Model} from "../decorators/model.decorator";
import {Column} from "../decorators/column.decorator";
import {BaseModel} from "./base.model";

@Model('currencyPrices', ['currencyBookPrices', 'currencyAuthorSavings', 'currencyDiscountedAuthorPrices'])
export class CurrencyPrice extends BaseModel {
  @Column()
  currency: string | undefined;
  @Column()
  netPrice: number | undefined;
  @Column()
  exchangeRate: number | undefined;
}
